import * as React from "react";
import { NavLink } from "react-router-dom";
import { withTranslation, WithTranslation } from "react-i18next";
import Axios, { AxiosResponse } from "axios";
import config from "../config";
import CoreComponent from "../pages/CoreComponent";
import { t } from "i18next";
import { IHolder, ICountry } from "../interfaces";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { arrayToFormData } from '../utils/functions';
import { toast } from "react-toastify";

interface IProps extends WithTranslation {
    isOpen: boolean,
    handleModal: any,
    holder?: IHolder,
}

interface IState {
    countries: ICountry[],
    isLoading: boolean,
    cities: string[]
}

class HolderModal extends CoreComponent<IProps, IState> {
    state: IState = {
        countries: [],
        isLoading: false,
        cities: []
    }

    async componentWillMount() {
        let response: AxiosResponse = await Axios.get(`${config.api}/user/country`);

        if (!this.isUnmounted) {
            this.setState({
                countries: response.data
            });
        }

        let response2: AxiosResponse = await Axios.get(`${config.api}/user/city`);

        if (!this.isUnmounted) {
            this.setState({
                cities: response2.data
            });
        }
    }

    async handleSubmit(data: any, setErrors: any) {
        let { t } = this.props;

        let formData = arrayToFormData(data);

        if (!this.isUnmounted) {
            this.setState({
                isLoading: true,
            }, async () => {
                let response: any;

                response = await Axios.post(`${config.api}/artist/create`, formData);

                if (response.data.status == "error") {
                    let errors: any = {};

                    for (let prop in response.data.errors) {
                        errors[prop] = response.data.errors[prop].join(", ");
                        toast(response.data.errors[prop].join(", "), { type: "error" });
                    }

                    if (!this.isUnmounted) {
                        this.setState({
                            isLoading: false
                        });
                    }

                    setErrors(
                        errors
                    );
                } else {
                    if (!this.isUnmounted) {
                        toast(t("Партнер сохранён."), { type: "success" });
                        this.setState({
                            isLoading: false
                        });

                        this.props.handleModal();
                    }
                }
            });
        }
    }

    render() {
        let holder = this.props.holder;

        let initialValues: any = holder ? {
            id: holder.id,
            first: holder.profile?.first,
            last: holder.profile?.last,
            day: holder.profile?.birthday ? holder.profile?.birthday.split("-")[2] : "",
            month: holder.profile?.birthday ? holder.profile?.birthday.split("-")[1] : "",
            year: holder.profile?.birthday ? holder.profile?.birthday.split("-")[0] : "",
            passport: holder.profile?.passport,
            country_id: holder.profile?.country_id || "",
            city: holder.profile?.city,
            email: holder.email,
            phone: holder.profile?.phone,
            username: holder.username,
            password: "",
            confirm_password: "",
            billing_first: holder.profile?.billing_first ? holder.profile.billing_first : "",
            billing_last: holder.profile?.billing_last ? holder.profile?.billing_last : "",
            billing_middle: holder.profile?.billing_middle ? holder.profile.billing_middle : "",
            billing_country_id: holder.profile?.billing_country_id ? holder.profile?.billing_country_id : "1",
            billing_city: holder.profile?.billing_city ? holder.profile?.billing_city : "Tashkent",
            billing_phone: holder.profile?.billing_phone ? holder.profile?.billing_phone : "",
            card: holder.profile?.card ? holder.profile?.card : "",
        } : {
                first: "",
                last: "",
                day: "",
                month: "",
                year: "",
                passport: "",
                country_id: "",
                city: "",
                card: "",
                email: "",
                phone: "",
                username: "",
                password: "",
                confirm_password: "",
                billing_first: "",
                billing_last: "",
                billing_middle: "",
                billing_country_id: "1",
                billing_city: "Tashkent",
                billing_phone: "",
            }

        let countries = this.state.countries;

        let { t } = this.props;

        return (
            <div className={"popup " + (this.props.isOpen ? "d-flex" : "")}>
                <div className="popup__content" style={{ height: "unset" }}>
                    <img onClick={() => this.props.handleModal()} src="img/Icon ionic-md-add.png" alt="" className="popup-del" />
                    <h1 className="popup__title">{!this.props.holder ? "Добавление партнера" : "Редактирование партнера"}</h1>
                    <Formik
                        enableReinitialize={true}

                        initialValues={initialValues}
                        onSubmit={async (values, { setErrors }) => {
                            await this.handleSubmit(values, setErrors);
                        }}

                        validationSchema={Yup.object().shape({
                            first: Yup.string().required(),
                            last: Yup.string(),
                            day: Yup.number(),
                            month: Yup.number(),
                            year: Yup.number(),
                            passport: Yup.string(),
                            billing_first: Yup.string(),
                            billing_last: Yup.string(),
                            billing_middle: Yup.string(),
                            billing_country_id: Yup.string(),
                            billing_city: Yup.string(),
                            billing_phone: Yup.string(),
                            card: Yup.string(),
                            country_id: Yup.number().nullable(),
                            city: Yup.string(),
                            email: Yup.string(),
                            phone: Yup.string(),
                            username: Yup.string().required(),
                            password: holder ? Yup.string() : Yup.string().required(),
                            confirm_password: holder ? Yup.string().test('passwords-match', 'Пароли не совподают', function (value) {
                                return this.parent.password === value;
                            }) : Yup.string().test('passwords-match', 'Пароли не совподают', function (value) {
                                return this.parent.password === value;
                            }).required(),
                        })}
                    >
                        {(props) => {
                            const {
                                values,
                                errors,
                                handleChange,
                                handleBlur,
                                handleSubmit,
                                touched,
                                setFieldValue,
                                setFieldTouched
                            } = props;

                            return (
                                <form id="official-signup" onSubmit={handleSubmit}>
                                    <div className="popup__items">
                                        <div className="popup__item">
                                            <span>Партнер:</span>
                                            <div className="form-holder">
                                                <input type="text" autoComplete="off" placeholder="Имя" name="first" value={values.first} onChange={handleChange} onBlur={handleBlur} className={(touched.first && errors.first ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Фамилия" name="last" value={values.last} onChange={handleChange} onBlur={handleBlur} className={(touched.last && errors.last ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Серия паспорта" name="passport" value={values.passport} onChange={handleChange} onBlur={handleBlur} className={(touched.passport && errors.passport ? "required" : "")} />
                                            </div>
                                            <span>Дата рождения:</span>
                                            <div className="form-date">
                                                <input type="text" autoComplete="off" placeholder="ДД" name="day" value={values.day} onChange={handleChange} onBlur={handleBlur} className={(touched.day && errors.day ? "required" : "")} />
                                                <span className="slash">/</span>
                                                <input type="text" autoComplete="off" placeholder="MM" name="month" value={values.month} onChange={handleChange} onBlur={handleBlur} className={(touched.month && errors.month ? "required" : "")} />
                                                <span className="slash">/</span>
                                                <input type="text" autoComplete="off" placeholder="ГГ" name="year" value={values.year} onChange={handleChange} onBlur={handleBlur} className={(touched.year && errors.year ? "required" : "")} />
                                            </div>
                                            <span>Страна/ Город</span>
                                            <div className="form-location" style={{ marginBottom: "40px" }}>
                                                <select name="country_id" value={values.country_id} onChange={handleChange} onBlur={handleBlur} className={(touched.country_id && errors.country_id ? "required" : "")}>
                                                    <option value="">Выберите страну...</option>
                                                    {countries.map((country: ICountry, i: number) => {
                                                        return (
                                                            <option value={country.id} key={i}>{country.name}</option>
                                                        );
                                                    })}
                                                </select>
                                                <input type="text" autoComplete="off" placeholder="Город" name="city" style={{ width: "205px" }} value={values.city} onChange={handleChange} onBlur={handleBlur} className={(touched.city && errors.city ? "required" : "")} />
                                            </div>
                                            <span>Биллинг:</span>
                                            <div className="form-holder">
                                                <input type="text" autoComplete="off" placeholder="Фамилия" name="billing_last" value={values.billing_last} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_last && errors.billing_last ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Имя" name="billing_first" value={values.billing_first} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_first && errors.billing_first ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Отчество" name="billing_middle" value={values.billing_middle} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_middle && errors.billing_middle ? "required" : "")} />
                                                {/* <input type="text" autoComplete="off" placeholder="Серия паспорта" name="billing_passport" value={values.billing_passport} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_passport && errors.billing_passport ? "required" : "")} /> */}
                                                <input type="text" autoComplete="off" placeholder="Телефон" name="billing_phone" value={values.billing_phone} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_phone && errors.billing_phone ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Номер карты" name="card" value={values.card} onChange={handleChange} onBlur={handleBlur} className={(touched.card && errors.card ? "required" : "")} />
                                            </div>
                                        </div>
                                        <div className="popup__item">
                                            <span>Контакты:</span>
                                            <div className="form-contacts">
                                                <input type="text" autoComplete="off" placeholder="Напишите почту" name="email" value={values.email} onChange={handleChange} onBlur={handleBlur} className={(touched.email && errors.email ? "required" : "")} />
                                                <input type="text" autoComplete="off" placeholder="Номер телефона" name="phone" value={values.phone} onChange={handleChange} onBlur={handleBlur} className={(touched.phone && errors.phone ? "required" : "")} />
                                            </div>
                                            <span>Данные для входа в Личный кабинет:</span>
                                            <div className="form-log">
                                                <input type="text" autoComplete="off" placeholder="Логин..." name="username" value={values.username} onChange={handleChange} onBlur={handleBlur} className={(touched.username && errors.username ? "required" : "")} />
                                                <input type="password" autoComplete="off" placeholder="Пароль" name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} className={(touched.password && errors.password ? "required" : "")} />
                                                <input type="password" autoComplete="off" placeholder="Подтвердите пароль" name="confirm_password" value={values.confirm_password} onChange={handleChange} onBlur={handleBlur} className={(touched.confirm_password && errors.confirm_password ? "required" : "")} />
                                                <button type="submit">
                                                    {this.state.isLoading ? (
                                                        <i className="fa fa-spinner fa-2x rotating "></i>
                                                    ) : (holder ? t("Редактировать") : t("Зарегистрировать"))}
                                                </button>
                                            </div>
                                            <span>Страна/ Город</span>
                                            <div className="form-location">
                                                <select name="billing_country_id" value={values.billing_country_id} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_country_id && errors.billing_country_id ? "required" : "")}>
                                                    <option value="">Выберите страну...</option>
                                                    {countries.map((country: ICountry, i: number) => {
                                                        return (
                                                            <option value={country.id} key={i}>{country.name}</option>
                                                        );
                                                    })}
                                                </select>
                                                <input type="text" autoComplete="off" placeholder="Город" list="cities" name="billing_city" style={{ width: "205px" }} value={values.billing_city} onChange={handleChange} onBlur={handleBlur} className={(touched.billing_city && errors.billing_city ? "required" : "")} />
                                                <datalist id="cities">
                                                    {this.state.cities.map((city: any, i: number) => {
                                                        return (
                                                            <option value={city.billing_city} key={i}>{city.billing_city}</option>
                                                        );
                                                    })}
                                                </datalist>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            );
                        }}
                    </Formik>

                </div>
            </div>
        );
    }
}

export default withTranslation()(HolderModal);